function stringToUrl(value) {
    var slug = require('slug')
    return slug(value);
}

export default stringToUrl